import React from "react";

// Styles & Assets
import styles from "./MessageChat.module.css";

// Components
import MediaDate from "../../Patient/MediaDate/MediaDate";

// Other
import moment from "moment";

// Interfaces
import { Color } from "../../../interfaces/Color";
import { IMessage } from "../../../interfaces/Chat";

interface Props {
  msg: IMessage;
  user: boolean;
  customSender?: string;
  showSender?: boolean;
  isFirstInGroup?: boolean;
  isLastInGroup?: boolean;
  color?: Color;
}

const MessageChat: React.FC<Props> = ({
  msg,
  user,
  customSender,
  showSender = false,
  isFirstInGroup = false,
  isLastInGroup = false,
  color = !user ? "#f2f2f2" : "#8fccff"
}) => {
  
  const isMedia = msg.dataType !== "TEXT";

  const senderName = customSender || msg.sender;

  return (
    <div
      style={{
        backgroundColor: color,
        marginTop: isFirstInGroup ? "10px" : "4px",
        marginBottom: isLastInGroup ? "10px" : "4px",
      }}
      className={`${styles.messageContainer} ${user ? styles.msgRight : styles.msgLeft} ${!isFirstInGroup && styles.msgLeftRightSender}`}
    >
      <div>
        {showSender && <p className={styles.sender}>{senderName}</p>}
      </div>
      <div className={`${styles.messageContentContainer} ${isMedia && styles.messageContentContainerMedia}`}>
        {!isMedia ? (
          <p className={styles.message}>{msg.content}</p>
        ) : (
          <MediaDate messages={[msg]} isGalleryMode={false}/>
        )}
        <p className={styles.time}>{moment(msg.timestamp).format("HH:mm")}</p>
      </div>
      {isFirstInGroup && (
        <div
          style={{ color: color }}
          className={`${styles.messageTriangle} ${user ? styles.triangleRight : styles.triangleLeft}`}
        ></div>
      )}
    </div>
  );
};

export default MessageChat;
